import type React from 'react';
import { useEffect } from 'react';
import { useMapInitialization } from '@/components/pages/MapPage/hooks/useMapInitialization';
import type { MapViewportProps } from './MapViewport.types';

/**
 * MapViewport Organism
 * Main map container with initialization logic
 * Handles map initialization, style loading, visibility management
 */
export const MapViewport: React.FC<MapViewportProps> = ({
  containerRef,
  onStyleLoad,
  onUserInteraction,
  className = '',
}) => {
  // Initialize map
  useMapInitialization({
    container: containerRef,
    onStyleLoad,
    onUserInteraction,
  });

  // Ensure map container is visible after initialization
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      requestAnimationFrame(() => {
        if (container) {
          container.style.visibility = 'visible';
          container.style.opacity = '1';
        }
      });
    }
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      className={`map-view ${className}`}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        visibility: 'visible',
        opacity: 1,
      }}
    />
  );
};
